import React from 'react'
import { LoadingButton } from '@mui/lab'

const MuiButtonLoading = ({ children, color, size, type, sx, variant, loading, endIcon, fullWidth, ...props }) => {
    return (
        <LoadingButton
            type={type ?? "button"}
            size={size ?? "medium"}
            color={color ?? "primary"}
            endIcon={endIcon ?? ' '}
            loading={loading ?? false}
            loadingPosition="end"
            variant={variant ?? "contained"}
            sx={{
                ...sx,
                lineHeight: 'normal',
                padding: '8px 20px',
                "&:disabled": {
                    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
                    color: color ? color+'.contrastText' : "primary.contrastText",
                    backgroundColor: color ? color+'.dark' : "primary.dark"
                }
            }}
            fullWidth={fullWidth ?? false}
            {...props}>
            {children}
        </LoadingButton>
    )
}

export default MuiButtonLoading
